import State from 'store/State';
import { selectWidgetsDataState } from 'widgets/store/selectors';
import { useSelector } from 'react-redux';

export const selectMyPortfolioCapsulesDataState = (state: State) =>
    selectWidgetsDataState(state).myPortfolioCapsulesData;

export const useSelectMyPortfolioCapsulesDataState = () =>
    useSelector(selectMyPortfolioCapsulesDataState);
